import type { $Fetch } from 'ofetch';
import type { ParcelaGateway } from '@/application/port/out/ParcelaGateway';
import type {
  CancelarParcelaCommand,
  CreateParcelaCommand,
  PagarParcelaCommand,
} from '@/application/port/in/dto/ParcelaCommand';
import type { Parcela } from '@/domain/model/Parcela';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const BASE = '/api/v1/matriculas';

export class HttpParcelaGateway implements ParcelaGateway {
  constructor(private readonly client: $Fetch) {}

  async list(matriculaId: string): Promise<Parcela[]> {
    const res = await this.client<ApiResponse<Parcela[]>>(
      `${BASE}/${encodeURIComponent(matriculaId)}/parcelas`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async create(command: CreateParcelaCommand): Promise<Parcela> {
    const res = await this.client<ApiResponse<Parcela>>(
      `${BASE}/${encodeURIComponent(command.matriculaId)}/parcelas`,
      {
        method: 'POST',
        body: {
          numeroParcela: command.numeroParcela,
          valor: command.valor,
          dataVencimento: command.dataVencimento,
          observacao: command.observacao,
        },
      },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async pagar(command: PagarParcelaCommand): Promise<Parcela> {
    const res = await this.client<ApiResponse<Parcela>>(
      `${BASE}/${encodeURIComponent(command.matriculaId)}/parcelas/${command.numeroParcela}/pagar`,
      {
        method: 'PATCH',
        body: command.dataPagamento
          ? { dataPagamento: command.dataPagamento }
          : {},
      },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async cancelar(command: CancelarParcelaCommand): Promise<void> {
    // Backend responde 204 No Content (sem envelope ApiResponse).
    await this.client<null>(
      `${BASE}/${encodeURIComponent(command.matriculaId)}/parcelas/${command.numeroParcela}`,
      { method: 'DELETE' },
    );
  }
}
